<p-dialog
  #fastCategoriaProd
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar categoria de produto</span>
      <i class="mdi mdi-shape-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="flex-column col-md-12 mt-3">
    <mat-form-field id="field-codigo" class="width-100" appearance="outline">
      <mat-label>
        Descrição
      </mat-label>
      <input
        matInput
        type="text"
        [formControl]="form.get('descricao')"
        (blur)="actionFnCheckEntityExist(form.get('descricao'))"
        autocomplete="off"
      />
    </mat-form-field>
    <small
      class="p-error"
      *ngIf="
        form.get('descricao').touched &&
        form.get('descricao').hasError('duplicate')
      "
    >
      {{ displayMessages.descricao.duplicate }}
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('descricao').touched &&
        form.get('descricao').hasError('required')
      "
    >
      {{ displayMessages.descricao.required }}
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('descricao').touched &&
        form.get('descricao').hasError('maxlength')
      "
    >
      {{ displayMessages.descricao.maxlength }}
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('descricao').touched &&
        form.get('descricao').hasError('isEmptyValue')
      "
    >
      {{ displayMessages.descricao.isEmptyValue }}
    </small>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="dialogRef.close()"
        [disabled]="loading"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="submit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
